import React from 'react'
import PropTypes from 'prop-types'

import { ReorderBanner } from '../ReorderBanner/ReorderBanner'
import { ReorderBannerPasswordless } from '../ReorderBanner/ReorderBannerPasswordless'
import { PopularItems } from '../PopularItems/PopularItems'
import { useAuth } from '../AuthProvider/AuthProvider'
import { useIsPasswordlessAuthEnabled } from '@local/do-secundo-passwordless-authentication'
import { useVariant } from '../../hooks/use-variant'
import { XP_POPULAR_ITEMS } from '../ExperimentsProvider/experiment-definitions'
import { Shelf } from 'cornucopia-apis'

const ReordersOrPopularItemsBanner = ({ hasReorders = false }) => {
  const { authenticated } = useAuth()
  const canReorder = hasReorders && authenticated
  const { PASSWORDLESS_ENABLED } = useIsPasswordlessAuthEnabled()
  const popularItemsVariant = useVariant(XP_POPULAR_ITEMS.experimentName)

  const getPopularItemsDisplay = (variant) => {
    switch (variant) {
      case 0:
        return null
      case 1:
        return <PopularItems />
      case 2:
        return <Shelf name='popular-items' />
      default:
        return <PopularItems />
    }
  }

  let reorderDisplay = <></>
  if (canReorder) {
    reorderDisplay = PASSWORDLESS_ENABLED ? (
      <ReorderBannerPasswordless />
    ) : (
      <ReorderBanner />
    )
  }

  return (
    <>
      {reorderDisplay}
      {getPopularItemsDisplay(popularItemsVariant)}
    </>
  )
}

ReordersOrPopularItemsBanner.propTypes = {
  hasReorders: PropTypes.bool.isRequired
}

export { ReordersOrPopularItemsBanner }
